import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styles from './AllAuthorsAndBookss.module.css';

import Title from '../../components/Title';
import Loading from '../../components/Loading';
import CardAuthor from '../../components/CardAuthor';
import CardBook from '../../components/CardBook';

export default function AllAuthorsAndBooks({ type }) {
  const [authors, setAuthors] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let url = '';

    if (type === 'authors') {
      url = 'https://back-cultura-sje-production.up.railway.app/get-authors';
    } else if (type === 'books') {
      url = 'https://back-cultura-sje-production.up.railway.app/get-books';
    }

    if (!url) return;

    axios.get(url)
      .then((response) => {
        if (type === 'authors') {
          setAuthors(response.data);
        } else if (type === 'books') {
          setBooks(response.data);
        }
      })
      .catch((error) => {
        console.error(`Erro ao buscar ${type}`, error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500);
      });

  }, [type]);

  if (loading) {
    return <Loading />
  }

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <div className={styles.title}>
          <Title color='var(--brown-300)'>
            {type === 'authors' ? 'Autores' : 'Livros'}
          </Title>
        </div>

        <div className={styles.cardsContainer}>
          {type === 'authors' && authors.map(author => (
            <Link key={author.id} to={`/autores/${author.id}`} className={styles.Links}>
              <CardAuthor
                nomeArtistico={author.nomeArtistico}
                generoLiterario={author.generoLiterario}
                foto={author.foto}
              />
            </Link>
          ))}

          {type === 'books' && books.map(book => (
            <Link key={book.id} to={`/autores/livros/${book.id}`} className={styles.Links}>
              <CardBook
                titulo={book.titulo}
                autor={book.autor.nomeArtistico}
                genero={book.genero}
                capa={book.capa}
                preco={book.preco}
              />
            </Link>
          ))}
        </div>
      </div>
    </main>
  )
}
